import { useEffect, useState } from 'react';
import * as Yup from 'yup';

import { generateYupSchema } from '../services/generateYupSchema';

export const useYupSchema = (subModules: string[]) => {
  const [yupSchema, setYupSchema] = useState<Yup.AnyObjectSchema>();

  useEffect(() => {
    const generateSchema = async () => {
      if (subModules?.length > 0 && subModules[0] !== '') {
        const newSchema = await generateYupSchema(subModules);
        setYupSchema(newSchema);
      }
    };
    generateSchema();
  }, [subModules]);

  return yupSchema as Yup.AnyObjectSchema;
};
